import {
    NotImplemented as NotImplementedType,
    FormConfig,
    FormValues
} from '@topdanmark-onlinesolutions/claim-form-types';

const NotImplemented = ({ value }: NotImplementedType) => {
    return <pre className="u-spacing-stack-m" dangerouslySetInnerHTML={{ __html: value }} />;
};

NotImplemented.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return true;
};

export default NotImplemented;
